import { z } from 'zod';

// https://docs.slace.com/docs/stoplight-docs-core/1fe63e8b55e4a-coupon
export const schemaSlaceCoupon = z.object({
    activity_id: z.string().optional(),
    attributes: z.record(z.string(), z.array(z.string())).optional(),
    channel_id: z.string().optional(),
    code: z.string(),
    contact_id: z.string(),
    conversation_id: z.string().optional(),
    created_at: z.string(),
    currency: z.string().optional(),
    description: z.string().optional(),
    display_code: z.string().optional(),
    display_expires_in: z.number().optional(),
    display_type: z.enum(['qr', 'barcode', 'text', 'none']),
    expires_at: z.string().optional(),
    expires_in: z.number().optional(),
    id: z.string(),
    interaction_id: z.string().optional(),
    last_seen_at: z.string().optional(),
    name: z.string(),
    redeemed_at: z.string().optional(),
    source: z.enum(['vouchery', 'vynamic', 'custom']),
    status: z.enum(['active', 'expired', 'redeemed']),
    total_amount: z.string().optional(),
    transaction_id: z.string().optional(),
    type: z.enum(['discount_percentage', 'discount_value', 'free_item', 'unknown']).optional(),
    value: z.string().optional(),
});

export type SchemaSlaceCoupon = z.infer<typeof schemaSlaceCoupon>;
